// Drives Turbo's navigation progress bar for long-running in-page work that isn't a Turbo visit.
// progressBar sits on Turbo's adapter, which is internal API, so every access is guarded rather
// than assumed.
export default class {
  static start() {
    const bar = this.progressBar()
    if (!bar) { return; }

    bar.setValue(0)
    bar.show()
  }

  static stop() {
    const bar = this.progressBar()
    if (!bar) { return; }

    bar.setValue(100)
    bar.hide()
  }

  static progressBar() {
    if (!window.Turbo || !Turbo.navigator || !Turbo.navigator.adapter) { return null; }

    return Turbo.navigator.adapter.progressBar || null
  }
}
